import { PaginationRequest } from '../config/common';

export class PaginationBranchRequest extends PaginationRequest {
    constructor();
    constructor(byPassBranch: boolean);
    constructor(byPassBranch: boolean, isConsignmetnSearch: boolean);
    constructor(byPassBranch?: boolean, isConsignmetnSearch?: boolean) {
        super();
        this.ByPassBranch = byPassBranch;
        this.IsConsignmentSearch = isConsignmetnSearch;
    }
    name?: string = '';
    code?: string;
    supplierCode?: string;
    isActive?: boolean;
}

export interface CreateBranchRequest {
    name?: string;
    code?: string;
    supplierCode?: string;
    isActive?: boolean;
    xeroOrganisationID?: string;
    isCompany1?: boolean
}
